import { Breadcrumb, Button, Flex } from '@applyboard/crystal-ui';

import { PageHeader } from '~/components/PageHeader';
import { ChangeProgramTable, ProgramDetails } from '../components';
import { BreadcrumbItem } from '../types';
import { useApplication } from '~/context';
import {
  CampusFilter,
  IntakeFilter,
  IntakesFilterSummary,
  IntakesPagination,
  QueryFilter,
  Sort,
  StatusFilter,
} from '~/components/Intake';

type MobileLayoutProps = {
  breadcrumbItems: BreadcrumbItem[];
};

export function MobileLayout(props: Readonly<MobileLayoutProps>) {
  const { application } = useApplication();

  const handleCancel = () => {
    window.location.href = `/applications/${application.id}`;
  };

  return (
    <Flex p={10} gap={3} direction="column">
      <Breadcrumb items={props.breadcrumbItems} />
      <Flex justify="between" align="stretch" direction="column">
        <PageHeader title="Change Primary Program Intake" />
        <Button intent="secondary" emphasis="outlined" onClick={handleCancel} width="fill">
          Cancel
        </Button>
      </Flex>
      <ProgramDetails lineSplit={true} />
      <Filter as={<QueryFilter />} width="100%" />
      <Filter as={<CampusFilter />} width="100%" />
      <Filter as={<IntakeFilter />} width="100%" />
      <Filter as={<StatusFilter />} width="100%" />
      <Filter as={<Sort showCreatedSort={false} />} width="100%" />
      <Flex pt={2}>
        <IntakesFilterSummary />
      </Flex>
      <ChangeProgramTable />
      <IntakesPagination />
    </Flex>
  );
}

type FilterProps = {
  as: React.ReactNode;
  width: string;
};

function Filter(props: Readonly<FilterProps>) {
  return <div style={{ width: props.width }}>{props.as}</div>;
}
